import React, { useState, useEffect, useRef } from "react";
import style from "./ActivityMenu.module.sass";
import trash from "../../../../../../assets/images/red-trash-without-circle.svg"
import download from "../../../../../../assets/images/download.svg"
import compare from "../../../../../../assets/images/compare.svg"
import email from "../../../../../../assets/images/email.svg"
import moveActivity from "../../../../../../assets/images/move-activity.svg"
import Modal from "../../../Modal/Modal";

function ActivityMenu(props) {
  const {
    actionsUrls,
    activeActions,
    deleteRedirect,
    patientName,
    translations,
    isOpen,
    license
  } = props;

  const [archiveState, setArchiveState] = useState("")
  const [enableDelete, setEnableDelete] = useState(false)
  const [showMenu, setShowMenu] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const ref = useRef();


  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation(); 
    setShowMenu(prev => !prev); 
  };



  const actionClick = (e, actionKey, actionKeyName) => {
    setPendingAction(actionKeyName);

    e.stopPropagation();
    const { url, method = "GET" } = actionKey;

    if (method.toUpperCase() === "GET") {
      window.location.href = url;
      setTimeout(() => {
        setShowMenu(false);
      }, 1000);
    } else {
      // POST “fire-and-forget” + eventuale feedback:
      fetch(url, { method: "POST" })
        .then(r => {
          setPendingAction(null); 
          if (r.ok){
            console.info(`${actionKey} OK`)
            setTimeout(() => {
              setShowMenu(false);
            }, 1000);
          }

        else{
           console.error(`${actionKey} KO`)
        }
    })
          ;
    }

  };

  const dropDownItem = (actionUrl, translation, src, actionKeyName) => {
    const isPending = pendingAction && actionKeyName === pendingAction;
  
    return (
      <div className={`${style.dropDownItem}`}
        onClick={(e) => actionClick(e, actionUrl, actionKeyName)}>
        <div className={style.iconContainer}>
          <img src={src} className={style.icon} />
        </div>
        <div style={{ paddingTop: "5px", paddingBottom: "5px" }}>
          {isPending ? translations.pendingTranslation : translation}
        </div>
      </div>
    )
  }

  const deleteActivity = (e, url) => {
    fetch(url, { method: 'POST' })
      .then((response) => {
        if (response.status == 200) {
          e.stopPropagation()
          setArchiveState("success")
        } else {
          e.stopPropagation()
          setArchiveState("error")
        }
      })
    e.preventDefault();
    e.stopPropagation();
  }

  const closeDeleteModal = (e) => {
    e.stopPropagation()
    setEnableDelete(false)
    setShowMenu(false)
    deleteRedirect()
  }

  const enableDeleteButton = (e) => {
    e.stopPropagation();
    setEnableDelete(!enableDelete);
  }

  useOnClickOutside(ref, () => setShowMenu(false));

  const dropDownClass = () => {
    if (activeActions.includes("show_sessions") || activeActions.includes("edit_sessions")) {
      return `${style.dropDown} ${style.large}`
    }
    return style.dropDown
  }



  return (
    <div className={style.activityMenu}>
    <div
      className={`${style.dotsContainer} ${
        (showMenu || (isOpen && license !== "euleria_lab")) ? style.dotsClicked : ""
      }`}
      onClick={(e) => handleClick(e)}
    >
      <strong style={{width:"60px",   textAlign:"center"}}> ••• </strong>
    </div>
      {showMenu &&
        <div ref={ref} className={dropDownClass()}>
          {activeActions.find(a => a == "compareResults") &&
            dropDownItem(actionsUrls.compareResults, translations.compareResults, compare)
          }
          {activeActions.find(a => a == "sendEmailPdf") &&
            dropDownItem(actionsUrls.sendEmailPdf, translations.sendEmailPdf, email, "sendEmailPdf")
          }
          {activeActions.find(a => a == "downloadCsv") &&
            dropDownItem(actionsUrls.downloadCsv, translations.downloadCsv, download)
          }

          {activeActions.find(a => a == "downloadPdf") &&
            dropDownItem(actionsUrls.downloadPdf, translations.downloadPdf, download)
          }

          {(activeActions.find(a => a == "compareResults") ||
            activeActions.find(a => a == "sendEmailPdf") ||
            activeActions.find(a => a == "downloadCsv") ||
            activeActions.find(a => a == "downloadPdf")) &&
            <div className={`${style.separator}`}>
            </div>
          }

          {activeActions.find(a => a == "moveActivity") &&
            dropDownItem(actionsUrls.moveActivity, translations.moveActivity, moveActivity)
          }

          {
            <div className={`${style.dropDownDeleteItem}`}
              id="confirmDelete">
              <div className={style.iconContainer}>
                <img src={trash} className={style.icon} />
              </div>
              <div style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                {translations.deleteActivity}
              </div>
            </div>
          }
          {
            <Modal
              background={true}

              closeButtons={["#cancelArchive"]}
              closeOnBackgroundClick={false}
              triggerButtons={["#confirmDelete"]} >
              <div className={style.deleteModal} onClick={(e) => e.stopPropagation()}>
                {archiveState == "" &&
                  <div>
                    <div className={style.title}>
                      {translations.modal.areYouSure}
                    </div>
                                        <div className={style.disclaimer}>
                                          {translations.modal.deleteDescription}
                                        </div>
                                        <div className={style.checkboxWrapper}>
                                          <input type="checkbox"
                                            id="confirmCheck"
                                            onChange={(e) => enableDeleteButton(e)} />
                                          <label htmlFor="confirmCheck"> {translations.modal.checkConfirm}</label>
                                        </div>
                    <div className={style.buttonsWrapper}>
                      <div className={style.cancel}
                        id="cancelArchive"
                        onClick={(e) => console.log("cancel")}>
                        {translations.modal.cancel}
                      </div>
                      <div className={enableDelete ? style.delete : style.disabledDelete}
                        onClick={(e) => deleteActivity(e, actionsUrls.deleteActivity.url)}>
                        {translations.modal.delete}
                      </div>
                    </div>
                  </div>
                }
                {archiveState == "success" &&
                  <div className={style.onResponse}>
                    <div className={style.successTitle}>{translations.modal.success}</div>
                    <div className={style.subTitle}>
                      {translations.modal.success_message}
                    </div>
                    <div className={style.disclaimer}>
                      {translations.modal.close_message}
                    </div>
                    <div className={style.cancel}
                      id="cancelArchive"
                      onClick={(e) => closeDeleteModal(e)}>
                      {translations.modal.close}
                    </div>
                  </div>
                }
                {archiveState == "error" &&
                  <div className={style.onResponse}>
                    <div>
                      <div className={style.title}>{translations.modal.error}</div>
                      <div className={style.subTitle}>
                        {translations.modal.error_message}
                        <br />
                        <br />
                        support@euleria.it
                      </div>
                      <div className={style.disclaimer}>
                        {translations.modal.close_message}
                      </div>
                      <div className={style.cancel}
                        id="cancelArchive"
                        onClick={(e) => closeDeleteModal(e)}>
                        {translations.modal.close}
                      </div>
                    </div>
                  </div>
                }
              </div>
            </Modal>
          }
        </div>
      }
    </div>
  )
}

// solution got from here: https://stackoverflow.com/a/68018429/1897170
function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      if (event.target.closest(".dotsContainer")) {
        return;
      }
      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}
ActivityMenu.propTypes = {
};

export default ActivityMenu;
